import React from 'react';
import ModalRouter from 'Components/Modals/ModalRouter';
import ViewContext, { advisorView } from 'Context/ViewContext';
import useAppState from 'Hooks/useAppState';
import { DebugProvider } from 'Context/DebugContext';
import MeetingContextProvider from 'Context/MeetingContext';
import NoteContextProvider from 'Context/NoteContext';
import AppContext from 'Context/AppContext';
import DebugPanel from 'Components/UI/DebugPanel';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import AdvisorContentRouterPicker from 'Components/AdvisorApp/AdvisorContentRouterPicker';
import { useSwaggerlessContext } from 'Context/SwaggerlessContext';

function AdvisorApp() {
  const { getNotifications, updateNotification, markNotificationsRead } = useSwaggerlessContext();

  const appApiMethods = {
    getNotifications,
    updateNotification,
    markNotificationsRead,
  };

  const appState = useAppState(appApiMethods);
  const { viewType, handleClose } = useIdentityChallengeContext();

  useComponentDidMount(null, () => {
    if (viewType) handleClose();
  });

  return (
    <DebugProvider initialState={null}>
      <ViewContext.Provider value={advisorView}>
        <AppContext.Provider value={appState}>
          <MeetingContextProvider>
            <NoteContextProvider>
              <ModalRouter modalScope="Advisor" />
              <AdvisorContentRouterPicker />
              <DebugPanel />
            </NoteContextProvider>
          </MeetingContextProvider>
        </AppContext.Provider>
      </ViewContext.Provider>
    </DebugProvider>
  );
}

AdvisorApp.propTypes = {
};

export default AdvisorApp;
